import type { ApolloClient } from '@apollo/client';
import type { RenderRuntimeDataServices } from '../../elements/types';
import { createAttributesService } from './attributes/service';
import { createCommentsService } from './comments/service';
import { createHighestReadingsService } from './highestReadings/service';
import { createLdenValuesService } from './ldenValues/ldenValuesService';
import { createAlarmExceedancesService } from './alarmExceedances/service';
import { createLeqAlarmExceedancesService } from './leqAlarmExceedances/service';
import { createLxnValuesService } from './lxnValues/service';
import { createMeasurementSettingsService } from './measurementSettings/service';
import { createLmaxAlarmExceedancesService } from './lmaxAlarmExceedances/service';
import { createMeasuringPointContextService } from './measuringPointContext/service';
import { createProjectMeasuringPointsService } from './projectMeasuringPoints/service';
import { createProjectContextService } from './projectContext/service';
import { createReportService } from './report/service';
import { createRuntimeDataServiceRegistry } from './registry';
import { createSystemAssetsService } from './systemAssets/service';
import { createTemplateOptionsService } from './templateOptions/service';
import { createTemplateResolveService } from './templateResolve/service';
import type { RuntimeDataServiceInstance } from './types';
import { createVperPeriodsService } from './vperPeriods/service';

function createRuntimeDataServiceInstances(
    client: ApolloClient<object>
): RuntimeDataServiceInstance[] {
    return [
        createProjectContextService(),
        createMeasuringPointContextService(),
        createReportService(),
        createAttributesService(client),
        createSystemAssetsService(client),
        createAlarmExceedancesService(client),
        createCommentsService(client),
        createLeqAlarmExceedancesService(client),
        createLmaxAlarmExceedancesService(client),
        createLdenValuesService(client),
        createVperPeriodsService(client),
        createHighestReadingsService(client),
        createLxnValuesService(client),
        createMeasurementSettingsService(client),
        createProjectMeasuringPointsService(client),
        createTemplateOptionsService(client),
        createTemplateResolveService(client),
    ];
}

export function createRuntimeDataServices(client: ApolloClient<object>): RenderRuntimeDataServices {
    return createRuntimeDataServiceRegistry(createRuntimeDataServiceInstances(client));
}
